/* SK 2026-10-13 (TD3): moved from inline <script> blocks at the end of layout/theme.liquid so browsers can cache it. Order preserved. */

/* --- from theme.liquid (line 584) --- */
function addShoppingListToCart() {
      const list = JSON.parse(localStorage.getItem('shoppingList')) || [];
      if (list.length === 0) return;

      const items = list.map(item => ({
        id: item.variantId,
        quantity: 1
      }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      }).then(() => location.reload());
    }
;

/* --- from theme.liquid (line 602) --- */
document.addEventListener('click', function (e) {
      const popupLink = e.target.closest('a[href*="?open=popup"]');
      const popupTrigger = e.target.closest('.popup-trigger');

      function openModal(id) {
        const modal = document.getElementById(id);
        if (!modal) {
          console.log('Popup not found:', id);
          return;
        }
        modal.style.display = 'block';
        modal.style.opacity = '1';
        modal.style.visibility = 'visible';
      }

      function closeModal(modal) {
        if (!modal) return;
        modal.style.display = 'none';
        modal.style.opacity = '';
        modal.style.visibility = '';
      }

      if (popupLink) {
        e.preventDefault();
        const href = popupLink.getAttribute('href') || '';
        const match = href.match(/[?&]open=(popup\d+)/);
        if (match && match[1]) {
          openModal(match[1]);
        }
        return;
      }

      if (popupTrigger) {
        e.preventDefault();
        const targetId = popupTrigger.getAttribute('data-target');
        if (targetId) {
          openModal(targetId);
        }
        return;
      }

      if (
        e.target.classList.contains('close-btn') ||
        e.target.classList.contains('close-btn2') ||
        e.target.classList.contains('custom-modal')
      ) {
        const modal = e.target.closest('.custom-modal') || e.target;
        closeModal(modal);
      }
    });


document.addEventListener('click', function(e) {
  // 1. Find the closest link that has the #open-popup1 or #open-popup2 hash
  const link1 = e.target.closest('a[href*="#open-popup1"]');
  const link2 = e.target.closest('a[href*="#open-popup2"]');

  if (link1) {
    e.preventDefault();
    const popup = document.getElementById('popup1');
    if (popup) popup.style.display = 'flex';
  }

  if (link2) {
    e.preventDefault();
    const popup = document.getElementById('popup2');
    if (popup) popup.style.display = 'flex';
  }

  // 2. Logic to close the popups
  if (e.target.classList.contains('close-btn') ||
      e.target.classList.contains('close-btn2') ||
      e.target.classList.contains('custom-modal')) {

    // Hide all modals
    document.querySelectorAll('.custom-modal').forEach(modal => {
      modal.style.display = 'none';
    });
  }
});
;

/* --- from theme.liquid (line 708) --- */
document.addEventListener('click', function(event) {
  // 1. Find the banner link specifically by its href
  var bannerLink = event.target.closest('a[href*="#open-popup1"]');

  if (bannerLink) {
    event.preventDefault(); // Stop the theme from navigating
    event.stopImmediatePropagation(); // Stop theme scripts from running

    var modal = document.getElementById('popup1');
    if (modal) {
      modal.style.display = 'flex';
      modal.style.zIndex = '999999'; // Ensure it's on top of the banner
    }
  }

  // 2. Simple Close Logic for the banner-triggered popup
  if (event.target.classList.contains('close-btn') || event.target.classList.contains('close-btn2')) {
    document.getElementById('popup1').style.display = 'none';
  }
}, true); // 'true' helps bypass theme sliders
;

/* --- from theme.liquid (line 730) --- */
document.addEventListener('click', function(event) {
  // Check if the clicked element (or its parent) is one of your FAQ links
  const toggle = event.target.closest('[data-toggle="collapse"]');

  if (toggle) {
    event.preventDefault();
    event.stopImmediatePropagation(); // This stops the "flicker" / double-close

    const targetId = toggle.getAttribute('href').replace('#', '');
    const targetPanel = document.getElementById(targetId);

    if (targetPanel) {
      // Toggle the 'in' class which Bootstrap 3 uses for visibility
      const isOpen = targetPanel.classList.contains('in');

      // Close all other panels (Accordion effect)
      document.querySelectorAll('.panel-collapse').forEach(panel => {
        panel.classList.remove('in');
      });

      // If it wasn't open, open it now
      if (!isOpen) {
        targetPanel.classList.add('in');
        toggle.classList.remove('collapsed');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        toggle.classList.add('collapsed');
        toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }
}, true); // The 'true' is important—it catches the click before other scripts
;

/* --- from theme.liquid (line 781) --- */
;(function(){
  document.addEventListener("click", function(e){
    var btn = e.target.closest(".dropdown-btn, .menu-arrow, li.menu-link > a[href='#']");
    if(!btn) return;
    var li = btn.closest("li.menu-link"); if(!li) return;
    var sub = li.querySelector("ul.ul-menu-dropdown"); if(!sub) return;
    e.preventDefault();
    var open = li.classList.toggle("submenu-open");
    sub.style.display = open ? "block" : "none";
    var b = li.querySelector(".dropdown-btn,.menu-arrow"); if(b) b.classList.toggle("active", open);
  }, true);
})();
;

/* --- from theme.liquid (line 796) --- */
/* Tidy Shopify's native data-sale opt-out form: uppercase the button + fix the cramped mobile layout */
  (function () {
    function fix(){
      document.querySelectorAll('button, input[type=submit], a[role=button]').forEach(function(el){
        var t=(el.value||el.textContent||'').trim();
        if(/^opt\s*out$/i.test(t)){
          el.style.textTransform='uppercase'; el.style.letterSpacing='.03em';
          el.style.display='block'; el.style.width='100%'; el.style.maxWidth='300px';
          el.style.padding='14px 20px'; el.style.margin='12px 0 0'; el.style.borderRadius='4px';
          var form=(el.closest && el.closest('form')) || el.parentElement;
          if(form){ form.style.marginBottom='48px'; }
        }
      });
    }
    document.addEventListener('DOMContentLoaded', function(){
      fix(); var mo=new MutationObserver(fix);
      if(document.body) mo.observe(document.body,{childList:true,subtree:true});
      setTimeout(function(){mo.disconnect();}, 8000);
    });
  })();
;

/* --- from theme.liquid (line 825) --- */
(function(){
    function bannerVisible(){
      var b=document.querySelector('#shopify-pc__banner, .shopify-pc__banner, [id*="pc__banner"]');
      if(!b) return false;
      var s=window.getComputedStyle(b);
      return s.display!=='none' && s.visibility!=='hidden' && b.offsetHeight>0;
    }
    function sync(){ if(document.body) document.body.classList.toggle('sk-consent-open', bannerVisible()); }
    document.addEventListener('DOMContentLoaded', function(){
      sync(); var mo=new MutationObserver(sync);
      mo.observe(document.documentElement,{childList:true,subtree:true,attributes:true});
    });
  })();
;
